// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"570":"e90d68ee","788":"58ccbc51","986":"1b8096b8"}[chunkId] + ".chunk.css";
};